/* eslint-disable react/jsx-indent */
import React, { Component, PropTypes } from 'react';
import { media } from 'style-utils';
import styled from 'styled-components';

import { connect } from 'react-redux';

import Paper from 'material-ui/Paper';

import { bindActionCreators } from 'redux';

import ProfileMenu from './ProfileMenu';

import RoleSelector from './RoleSelector';

import CountrySwitcher from './CountrySwitcher';

import { getCurrentRole } from './selector';

import * as globalActions from '../../../action/CommonActions';

import isIframe from '../../../utils/isIframe';
import { getProfileMenu } from '../../../layouts/selector';

import ProfileIcon from './ProfileIcon';

import Breakpoint from '../../../utils/breakpoints';

import { HeaderIcon, MobileHeader } from '../Menu/Sidebar/styles';

const appMenu = [
  {
    title: 'Profile',
    url: '/v2/user/management/profile'
  },
  {
    title: 'Logout',
    route: '/logout'
  }
];

// disable display of change password & logout if iframed
// const accountMenu = isIframe ? menu.slice(0, 2) : menu;

const ProfileContainer = styled.section`
  position: relative;
  display: flex;
  align-content: center;
  color: ${props => props.theme.color.white};
`;

// have to look at blody zindexes for logo , profile and search bar - SRIRAM
const Profile = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0 0 0 32px;

  ${media.mobileTablet`
    padding: 16px 20px 16px 4px;
  `}

  overflow: hidden;
  display: flex;
  align-content: center;
`;

const Avatar = styled.div`
  float: left;
  margin-top: 3px;
  margin-right: 8px;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  & path {
    & path {
      fill: ${props => props.theme.color.gunmetal};
    }
  }
  ${media.mobileTablet`
    padding:0;
    margin:0;
    width: 16px;
    height: 16px;
    }
  }
  `}
`;

const ProfileNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  white-space: nowrap;
  text-align: left;
  width: 145px;
  color: ${props => props.theme.color.black};
`;

const ProfileName = styled.div`
  font-family: ${props => props.theme.font.bold};
  display: flex;
  flex-direction: row;
  width: 145px;
  justify-content: space-between;
`;
const ProfileRole = styled.div`
  opacity: 0.5;
  width: 135px;
`;

const ProfileMenuPopover = styled.div`
  position: absolute;
  width: 350px;
  right: 0;
  padding-top: 8px;
  display: block;
  z-index: 1;
  opacity: 0;
  transform: scale(0);
  top: 100%;
  transition: transform 0s 0.3s, opacity 0.3s ease-out;

  ${media.tablet`
    margin: -10px 16px;
    padding-top: 0;
  `}

  ${media.mobile`
    margin: 0;
    padding-top: 0;
    width: 100vw;
    z-index: 1501;
    top: -2px;
  `}

  ${props =>
    props.open &&
    `
      opacity: 1;
      transform: scale(1);
      transition: transform 0s, opacity .3s ease-out;
      pointer-events: all;
    `}
`;

const RoleSelectorContainer = styled.section`
  padding: 20px 0;
  margin: 0 16px;
  border-bottom: 1px solid ${props => props.theme.color.border};
`;
export const DialogContainer = styled.div`
  position: absolute;
  bottom: 0;
  height: 110vh;
  width: 100vw;
  top: -10px;
  right: 0;
  opacity: 0.5;
  transition: left 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    opacity 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1500;
  pointer-events: auto;
  & span {
    z-index: 1501;
    float: right;
  }
`;

class ProfileComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  componentDidMount() {
    // Fix for MS on touch device
    this.touchEvent =
      typeof document.ontouchstart === 'undefined' ? 'click' : 'touchstart';
    document.addEventListener(this.touchEvent, this.handleOutsideClick, false);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.location &&
      nextProps.location.pathname !== this.props.location.pathname
    ) {
      this.setState({ open: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      this.touchEvent,
      this.handleOutsideClick,
      false
    );
  }

  onMenuLinkClick = menuOption => {
    this.close();
    if (menuOption.route) {
      this.context.router.push({
        pathname: menuOption.route
      });
    } else if (menuOption.url) {
      // Open Profile page in same tab
      window.open(
        menuOption.url,
        menuOption.url === '/v2/user/management/profile' ? '_self' : '_blank'
      );
    }
  };

  handleOutsideClick = e => {
    if (!e.target || !this.profileEl || this.profileEl.contains(e.target)) {
      return false;
    }

    return this.close();
  };

  close = () => this.setState({ open: false });

  toggle = e => {
    // Prevents ghost clicking on touch devices
    e.preventDefault();
    this.setState({ open: !this.state.open });
  };

  render() {
    const { firstName, lastName, role, avatarOnly, profileMenu } = this.props;

    let finalMenu = [
      {
        title: 'My bookmarks',
        route: '/my-bookmarks'
      },
      ...profileMenu
    ];

    if (!isIframe) {
      finalMenu = finalMenu.concat(appMenu);
    }

    return (
      <ProfileContainer innerRef={element => (this.profileEl = element)}>
        <Breakpoint name="desktop">
          <CountrySwitcher />
        </Breakpoint>
        <Profile onClick={this.toggle}>
          <Avatar>
            <ProfileIcon fillColor={avatarOnly ? '#ffffffff' : '#4d4f54'} />
          </Avatar>
          {!avatarOnly && (
            <ProfileNameContainer>
              <ProfileName>{`${firstName} ${lastName}`}</ProfileName>
              {role && <ProfileRole>{role.label}</ProfileRole>}
            </ProfileNameContainer>
          )}
        </Profile>

        <ProfileMenuPopover open={this.state.open}>
          {this.state.open && (
            <Breakpoint name="mobile">
              <MobileHeader>
                <span />
                <HeaderIcon
                  name="close"
                  size={15}
                  variant="white"
                  action={this.toggle}
                />
              </MobileHeader>
            </Breakpoint>
          )}
          <Paper>
            {this.state.open && (
              <Breakpoint name="mobileTablet">
                <CountrySwitcher close={this.close} />
              </Breakpoint>
            )}
            <RoleSelectorContainer>
              <RoleSelector close={this.close} displayHeading={false} />
            </RoleSelectorContainer>
            <ProfileMenu
              menus={finalMenu}
              onMenuLinkClick={this.onMenuLinkClick}
            />
          </Paper>
        </ProfileMenuPopover>

        <Breakpoint name="mobile">
          {this.state.open && <DialogContainer />}
        </Breakpoint>
      </ProfileContainer>
    );
  }
}

ProfileComponent.contextTypes = {
  router: PropTypes.shape({})
};

ProfileComponent.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  username: PropTypes.string,
  role: PropTypes.shape({}),
  location: PropTypes.shape({}),
  avatarOnly: PropTypes.bool
};

const mapStateToProps = state => ({
  role: getCurrentRole(state),
  firstName: state.auth.firstName,
  lastName: state.auth.lastName,
  username: state.auth.username,
  profileMenu: getProfileMenu(state)
});

const mapDispatchToProps = dispatch => ({
  globalActions: bindActionCreators(globalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileComponent);



// WEBPACK FOOTER //
// ./src/components/common/Profile/Profile.js